import { render, staticRenderFns } from "./DestinoSelect.vue?vue&type=template&id=963b55d0&"
import script from "./DestinoSelect.vue?vue&type=script&lang=js&"
export * from "./DestinoSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports